import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import Image from 'gatsby-theme-core/src/components/image';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Container from 'gatsby-theme-core/src/components/container';
import Content from 'gatsby-theme-core/src/components/content';
import dateFormat from 'gatsby-theme-pdv/src/helpers/date-format';
import SocialWidget from 'gatsby-theme-pdv/src/components/social-widget';

const regexRemoveHtml = /(<([^>]+)>)/ig;

const Post = ({
  title,
  date,
  author,
  content,
  featuredImage,
  excerpt,
  highlightedPosts,
  path,
  lang = 'nl',
}) => {
  const head = {
    headPageTitle: title,
    headTitle: `${title}, ${dateFormat(date)}, ${author.node.name}`,
    headSlug: path,
    headMetaDescription: excerpt.replace(regexRemoveHtml, '').replace('[&hellip;]', '...'),
    headImage: featuredImage?.node ? {
      src: featuredImage.node.mediaItemUrl,
      width: featuredImage.node.mediaDetails?.width,
      height: featuredImage.node.mediaDetails?.height,
    } : null,
  };

  return (
    <Layout {...head}>
      <PostWrapper lang={lang}>
        {featuredImage?.node && (
          <Container css="margin-bottom: 3rem">
            <Image
              image={featuredImage.node}
            />
          </Container>
        )}
        <Container small>
          <Title dangerouslySetInnerHTML={{ __html: title }} />
          <Info>{dateFormat(date)}, {author.node.name}</Info>
          <Content $content={content} />
        </Container>
      </PostWrapper>
      <Container>
        <HighlightedPostsTitle>Lees ook</HighlightedPostsTitle>
        <HighlightedPosts>
          {highlightedPosts.map((highlightedPost) => (
            <HighlightedPost key={highlightedPost.id}>
              <Link to={highlightedPost.path}>
                {highlightedPost?.featuredImage?.node && (
                  <Image
                    image={highlightedPost.featuredImage.node}
                  />
                )}
                <span>{dateFormat(highlightedPost.date)}</span>
                <h3
                  dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                    __html: highlightedPost.title,
                  }}
                />
              </Link>
            </HighlightedPost>
          ))}
        </HighlightedPosts>
      </Container>
      <SocialWidget />
    </Layout>
  );
};

export default Post;

const PostWrapper = styled.article`
  background-color: ${(props) => props.theme.gray1};
  padding: 60px 0;
`;

const Title = styled.h1`
  margin: 0;
  padding-bottom: 40px;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 2rem;
  line-height: 2.5rem;
  text-transform: uppercase;
`;

const Info = styled.span`
  display: block;
  text-transform: uppercase;
  font-size: 0.8889rem;
  color: ${(props) => props.theme.secondaryColor};
`;

const HighlightedPosts = styled.section`
  overflow: auto;
  padding-bottom: 60px;
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 26.666666666666667px;
`;

const HighlightedPost = styled.article`
  min-width: 280px;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    min-width: auto;
  }
  &:hover {
    h3 {
      color: ${(props) => props.theme.primaryColor};
    }
  }
  a {
    text-decoration: none;
  }
  span {
    padding: 15px 0;
    display: block;
    font-size: 0.8889rem;
    text-transform: uppercase;
    color: ${(props) => props.theme.gray3};
  }
  h3 {
    margin: 0;
    font-family: ${(props) => props.theme.standoutFontFamily};
    font-size: 1.222rem;
    color: ${(props) => props.theme.backgroundColor};
  }
`;

const HighlightedPostsTitle = styled.h2`
  margin: 0;
  padding: 60px 0 30px 0;
  font-family: ${(props) => props.theme.standoutFontFamily};
  font-size: 1.556rem;
  text-transform: uppercase;
`;
